import type { ProcessType } from 'shared/domain/process/types/model';

let cachedProcesses: ProcessType[] = [];
let hasCachedSnapshot = false;

export function getCachedProcesses(): ProcessType[] {
  return cachedProcesses;
}

export function hasCachedProcessesSnapshot(): boolean {
  return hasCachedSnapshot;
}

export function setCachedProcesses(processes: ProcessType[]): void {
  cachedProcesses = processes;
  hasCachedSnapshot = true;
}

export function clearCachedProcesses(): void {
  cachedProcesses = [];
  hasCachedSnapshot = false;
}
